import { gql } from '@apollo/client'

export interface RetroCommissionSnapshot {
  id: number
  periodStart: string
  periodEnd: string
  monthlyRevenueAmount: number
  commissionAmount: number
  activeCount: number
  unpaidCount: number
  totalCount: number
  canceledCount: number
  newCustomersCount: number
  // newUnpaidCount: number
  // unpaidRegularizedCount: number
  newCancelationsCount: number
  bookingRoomRevenueAmount: number
  bookingRoomCommissionAmount: number
  businessReferralAmount: number
}

export interface DateRange {
  startDate: Date
  endDate: Date
}

export interface BillingAddress {
  id: number
  shortname: string
  fullAddress: string
  partnerBillingSpace: boolean
  retroCommissionDisplayRevenue: boolean
  retroCommissionSnapshots: RetroCommissionSnapshot[]
}

export const PARTNER_RETRO_COMMISSION_SNAPSHOTS = gql`
  query PartnerRetroCommissionSnapshots(
    $periodFrom: ISO8601DateTime
    $periodTo: ISO8601DateTime
  ) {
    currentAddresses {
      id
      shortname
      fullAddress
      partnerBillingSpace
      retroCommissionDisplayRevenue
      retroCommissionSnapshots(periodFrom: $periodFrom, periodTo: $periodTo) {
        id
        periodStart
        periodEnd
        monthlyRevenueAmount
        commissionAmount
        activeCount
        unpaidCount
        totalCount
        canceledCount
        newCustomersCount
        # newUnpaidCount
        # unpaidRegularizedCount
        newCancelationsCount
        bookingRoomRevenueAmount
        bookingRoomCommissionAmount
        businessReferralAmount
      }
    }
  }
`
